<h1 mat-dialog-title style="color: #185638">{{ data.title }}</h1>
<div mat-dialog-content style="white-space: pre-line">
  {{ data.message }}
</div>
<div mat-dialog-actions class="dialog">
  <button mat-flat-button type="button" color="primary" (click)="onOkClick()">關閉</button>
</div>
